import { API, graphqlOperation } from "aws-amplify";
import { dateToAWSDate } from "@/services/Formatting.js";

const SEARCH_CATEGORY = {
  ByActionDate: "byActionDate",
  ByOperationType: "byOperationType",
  ByUser: "byUser"
};

const DEFAULT_DATE_RANGE = () => {
  const from = new Date();
  from.setDate(from.getDate() - 7);
  const to = new Date();
  to.setDate(to.getDate() + 1);
  return {
    from,
    to
  };
};

const DEFAULT_SEARCH_MODEL = {
  userEmail: "",
  operationType: ["any"],
  dateRange: DEFAULT_DATE_RANGE
};

const DEFAULT_AMOUNT_OF_RECORDS_TO_RETRIEVE_FROM_BACKEND = 20;

const OPERATION_TYPES = {
  AddMerchantInformation: { text: "Add Merchant Information" },
  Collect: { text: "Collect" },
  DeleteUser: { text: "Delete User" },
  EditUserPermissions: { text: "Edit User Permissions" },
  ListPermissions: { text: "List Permissions" },
  OnBoardMerchant: { text: "Onboard Merchant" },
  PartialCollect: { text: "Partial Collect" },
  PartialRefund: { text: "Partial Refund" },
  Refund: { text: "Transaction Refund" },
  Reversal: { text: "Transaction Reversal" },
  SaveFacCredentials: { text: "Save Fac Credentials" },
  UpdateMerchantInformation: { text: "Update Merchant Information" },
  ViewTransactionLog: { text: "View Transaction Log" },
  ViewTransactions: { text: "View Transactions" },
  ViewUserPermissions: { text: "View User Permissions" },
  ViewUsers: { text: "View Users" }
};

export default {
  data() {
    return {
      activities: [],
      search: "",
      loading: false,
      nextToken: null,
      searchModel: {
        userEmail: DEFAULT_SEARCH_MODEL.userEmail,
        operationType: DEFAULT_SEARCH_MODEL.operationType,
        dateRange: DEFAULT_SEARCH_MODEL.dateRange()
      },
      operationTypes: OPERATION_TYPES
    };
  },
  computed: {
    isAdmin() {
      return this.$role.verify([this.$role.ADMIN]);
    },
    tenantAlias() {
      const alias = this.$store.getters.merchantId;
      if (!alias && this.isAdmin) return this.$role.ADMIN;
      return alias;
    },
    searchCategory() {
      if (this.isUserEmailSet) return SEARCH_CATEGORY.ByUser;

      if (this.isOperationTypeSet) return SEARCH_CATEGORY.ByOperationType;

      return SEARCH_CATEGORY.ByActionDate;
    },
    isUserEmailSet() {
      return !!this.searchModel.userEmail && this.searchModel.userEmail != "";
    },
    isOperationTypeSet() {
      const operationSearch = this.searchModel.operationType;
      return (
        !!operationSearch &&
        !!operationSearch.length &&
        !operationSearch.includes("any")
      );
    },
    formatedDateRangeFrom() {
      return this.formatDateForBackEnd(this.searchModel.dateRange.from);
    },
    formatedDateRangeTo() {
      return this.formatDateForBackEnd(this.searchModel.dateRange.to);
    }
  },
  methods: {
    async getActivities(nextToken) {
      const searchActivityLog = `
          query SearchActivityLog(
            $body: QuerySearchActivityLogBodyInput
          ) {
            searchActivityLog(body: $body) {
              nextToken
              data{
                actionDate
                operationType
                detail
                userEmail
                userName
              }
            }
          }
        `;

      const searchCategory = this.searchCategory;
      const tenantAlias = this.tenantAlias;
      const dateRange = {
        startDate: this.formatedDateRangeFrom,
        endDate: this.formatedDateRangeTo
      };
      let userEmail = null;
      let operationType = null;
      if (this.isUserEmailSet) {
        userEmail = this.searchModel.userEmail;
      }

      if (this.isOperationTypeSet) {
        operationType = this.searchModel.operationType[0];
      }

      let filter = {
        limit: DEFAULT_AMOUNT_OF_RECORDS_TO_RETRIEVE_FROM_BACKEND,
        nextToken
      };

      const searchActivityLogQuery = {
        searchCategory,
        tenantAlias,
        dateRange,
        userEmail,
        operationType,
        filter
      };

      const searchResponse = await API.graphql(
        graphqlOperation(searchActivityLog, {
          body: searchActivityLogQuery
        })
      );

      this.nextToken = searchResponse.data.searchActivityLog.nextToken;

      return searchResponse.data.searchActivityLog.data;
    },
    async getFormatedActivities(nextToken) {
      const activities = await this.getActivities(nextToken);
      return activities.map(this.formatActivities);
    },
    async searchEvent() {
      this.loading = true;
      try {
        this.activities = await this.getFormatedActivities();
      } catch (err) {
        this.loading = false;
        throw err;
      }
      this.loading = false;
    },
    async loadMoreActivities() {
      if (!this.nextToken) return;
      this.loading = true;
      try {
        const newActivities = await this.getFormatedActivities(this.nextToken);
        this.activities = this.activities.concat(newActivities);
      } catch (err) {
        this.loading = false;
        throw err;
      }
      this.loading = false;
    },
    resetSearch() {
      this.searchModel.userEmail = DEFAULT_SEARCH_MODEL.userEmail;
      this.searchModel.operationType = DEFAULT_SEARCH_MODEL.operationType;
      this.searchModel.dateRange = DEFAULT_SEARCH_MODEL.dateRange();
    },
    extractDateFromTime(dateTime) {
      const date = new Date(dateTime);
      let dateString = date.toDateString();
      dateString = dateString.substr(dateString.indexOf(" ") + 1);
      const timeString = date.toLocaleTimeString();
      return `${dateString}\n${timeString}`;
    },
    formatActivities(activity) {
      activity.actionDate = this.extractDateFromTime(activity.actionDate);

      return activity;
    },
    formatDateForBackEnd(date) {
      return dateToAWSDate(date);
    }
  }
};
